module.exports = __webpack_public_path__ + "static/img/goBtn.b8f9c04a.png";